import angular from 'angular'

import component from './device.component'
import progressbar from 'angular-ui-bootstrap/src/progressbar'

let module = angular.module('device', [progressbar])

.component('device', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/device/index.js